import { render, staticRenderFns } from "./UniqueApproach.vue?vue&type=template&id=f550b32a&"
import script from "./UniqueApproach.vue?vue&type=script&lang=js&"
export * from "./UniqueApproach.vue?vue&type=script&lang=js&"
import style0 from "./UniqueApproach.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports